import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Inicio',
    href: '/'
  }, {
    name: 'Servicios',
    href: '/servicios'
  }, {
    name: 'Proceso',
    href: '/proceso'
  }, {
    name: 'Resultados',
    href: '/resultados'
  }, {
    name: 'FAQ',
    href: '/faq'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#0a0a0a]/90 backdrop-blur-md border-b border-white/[0.05] py-4' : 'bg-transparent border-b border-transparent py-6'}`} data-id="element-137">
      <div className="container mx-auto px-6 md:px-12 flex items-center justify-between relative z-10" data-id="element-138">
        <Link to="/" className="flex items-center gap-2 z-50 relative group" data-id="element-139">
          <img src="https://cdn.magicpatterns.com/uploads/9eqxLFx7HNRwaS7nTrWySg/Captura_de_pantalla_2026-04-28_a_las_19.45.31-removebg-preview.png" alt="Growthly Logo" className="h-6 md:h-7 object-contain relative z-10 filter brightness-0 invert transition-opacity duration-300 group-hover:opacity-80" data-id="element-140" />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8" data-id="element-141">
          <div className="flex items-center gap-8" data-id="element-142">
            {navLinks.map(link => {
            const isActive = location.pathname === link.href;
            return <Link key={link.name} to={link.href} className={`text-[13px] font-medium transition-colors ${isActive ? 'text-white' : 'text-gray-400 hover:text-white'}`} data-id="element-143">
                  {link.name}
                </Link>;
          })}
          </div>
          <Link to="/checkout" className="bg-brand-emerald text-[#0a0a0a] px-5 py-2 rounded-lg text-[13px] font-medium hover:bg-brand-emeraldLight transition-colors" data-id="element-144">
            Empezar ahora
          </Link>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="lg:hidden z-50 p-2 text-gray-400 hover:text-white transition-colors" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-145">
          {isMobileMenuOpen ? <X size={20} data-id="element-146" /> : <Menu size={20} data-id="element-147" />}
        </button>

        {/* Mobile Nav */}
        <AnimatePresence data-id="element-148">
          {isMobileMenuOpen && <motion.div initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -10
        }} transition={{
          duration: 0.2
        }} className="absolute top-0 left-0 right-0 bg-[#0a0a0a] h-screen pt-24 px-6 flex flex-col gap-6 border-b border-white/[0.05] lg:hidden" data-id="element-149">
              <div className="flex flex-col gap-2" data-id="element-150">
                {navLinks.map(link => {
              const isActive = location.pathname === link.href;
              return <Link key={link.name} to={link.href} onClick={() => setIsMobileMenuOpen(false)} className={`text-lg font-medium border-b border-white/[0.05] py-4 transition-colors ${isActive ? 'text-brand-emerald' : 'text-gray-300 hover:text-white'}`} data-id="element-151">
                      {link.name}
                    </Link>;
            })}
              </div>
              <div className="mt-6" data-id="element-152">
                <Link to="/checkout" onClick={() => setIsMobileMenuOpen(false)} className="bg-brand-emerald text-[#0a0a0a] text-center px-6 py-3.5 rounded-xl text-[15px] font-medium block" data-id="element-153">
                  Empezar ahora
                </Link>
              </div>
            </motion.div>}
        </AnimatePresence>
      </div>
    </header>;
}